import { Container } from "@molecules";
import { Message } from "@templates";

export default function NotFound() {
  return (
    <Container>
      <Message>
        <Message.Emoji>🤷</Message.Emoji>
        <Message.Title>¡Uy! No encontramos esa página.</Message.Title>
        <Message.Body>404</Message.Body>
        <Message.Footer>
          Si necesitás más ayuda escribinos a{" "}
          <a href="mailto:hola@nubi.com.ar">hola@nubi.com.ar</a>
        </Message.Footer>
      </Message>
    </Container>
  );
}
